var dd = require('react-dd');
var _ = require('lodash');

module.exports = dd.createClass({
	render: function(){
		var horizontal = !!this.props.horizontal;
		var layout_shiz = make_layout_portions(_.map(this.props.children, function(elm, i){
			return num_or_null(horizontal ? elm.width : elm.height);
		}));

		return dd.div({style: {
				height: '100%'
			}},
			_.map(this.props.children, function(elm, i){
				var style = {
					position: 'absolute'
				};

				if(horizontal){
					style.top = 0;
					style.bottom = 0;

					if(layout_shiz[i].before !== null){
						style.left = layout_shiz[i].before;
					}
					if(layout_shiz[i].after !== null){
						style.right = layout_shiz[i].after;
					}
					if(layout_shiz[i].size !== null){
						style.width = layout_shiz[i].size;
					}
				}else{
					style.right = 0;
					style.left = 0;

					if(layout_shiz[i].before !== null){
						style.top = layout_shiz[i].before;
					}
					if(layout_shiz[i].after !== null){
						style.bottom = layout_shiz[i].after;
					}
					if(layout_shiz[i].size !== null){
						style.height = layout_shiz[i].size;
					}
				}
				return dd.div({key: i, style: style}, elm.body);
			})
		);
	}
});

var num_or_null = function(n){
	return _.isNumber(n) && !_.isNaN(n) && n >= 0 ? n : null;
};

var sum_until_null = function(arr){
	var null_mode = false;
	var sum = 0;
	return _.map(arr, function(size){
		var result = null_mode ? null : sum;
		if(size === null){
			null_mode = true;
		}else if(!null_mode){
			sum += size;
		}
		return result;
	});
};

var make_layout_portions = function(sizes){
	var befores = sum_until_null(sizes);
	var afters = sum_until_null(_.clone(sizes).reverse()).reverse();
	return _.map(sizes, function(size, i){
		return {
			size: size,
			before: befores[i],
			after: afters[i]
		};
	});
};

module.exports.__for_testing__ = {
	make_layout_portions: make_layout_portions,
	sum_until_null: sum_until_null
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/FullLayout.js
// module id = 82
// module chunks = 0 1 2 3 4